export const GAP_BENEFICIARY_ACTIONS = {
  SET_DATA: 'GAP_BENEFICIARY/SET_DATA',
  SET_EXISTING: 'GAP_BENEFICIARY/SET_EXISTING',
  RESET: 'GAP_BENEFICIARY/RESET',
};

const initialState = {
  firm_owner_name: '',
  firm_type: '',
  beneficiary: {
    beneficiary_id: 0,
    document_id: '',
    pan: '',
    full_name: '',
    gender: '',
    dob: '',
    phone_number: '',
    relation: 'Self',
  },
};

export const setGapBeneficiaryData = (payload) => ({
  type: GAP_BENEFICIARY_ACTIONS.SET_DATA,
  payload,
});

export const setGapExistingBeneficiary = (beneficiary) => ({
  type: GAP_BENEFICIARY_ACTIONS.SET_EXISTING,
  payload: beneficiary,
});

export const resetGapBeneficiary = () => ({
  type: GAP_BENEFICIARY_ACTIONS.RESET,
});

const gapBeneficiaryReducer = (state = initialState, action) => {
  switch (action.type) {
    case GAP_BENEFICIARY_ACTIONS.SET_DATA:
      return { ...state, ...action.payload };

    case GAP_BENEFICIARY_ACTIONS.SET_EXISTING:
      return {
        ...state,
        beneficiary: {
          ...initialState.beneficiary,
          beneficiary_id: action.payload.id,
          full_name: action.payload.header_title,
        },
      };

    case GAP_BENEFICIARY_ACTIONS.RESET:
      return initialState;

    default:
      return state;
  }
};

export default gapBeneficiaryReducer;
